import { Divider, VStack, View } from "@gluestack-ui/themed";
import { SecondCopyOfReceiptController } from "./controller";
import { TransactionInfoSection } from "@repo/core/components/receipt/sections/TransactionInfoSection";
import { StoreInfoSection } from "@repo/core/components/receipt/sections/StoreInfoSection";
import { ClientInfoSection } from "@repo/core/components/receipt/sections/ClientInfoSection";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import { ReceiptFooterSection } from "@repo/core/components/receipt/sections/ReceiptFooterSection";
import { formatDateTime } from "@repo/core/utils/date.utils";
import { ShareButton } from "@repo/core/components/core/ShareButton";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const SecondCopyOfReceipt = () => {
  const {
    back,
    isMobile,
    handleGoToSales,
    data,
    handleSendSMS,
    viewRef,
    handleCaptureAndGeneratePDF,
    isLoading
  } = SecondCopyOfReceiptController();

  if (!data?.autorizacao) {
    return null;
  }

  return (
    <Scaffolds.Root
      minHeight="$100vh"
      title="Comprovante de Transação"
      onBackPress={back}
      rightIcon="times"
      rightIconSize={20}
      rightWebLabel="Fechar"
      onPressRightIcon={handleGoToSales}
      statusBarVariant={StatusBarVariantEnum.LIGHT}
    >
      <Scaffolds.Form
        showHeader={false}
        footerContent={
          <View
            w="$full"
            gap="$4"
            flexDirection={!isMobile ? "row-reverse" : "column"}
            justifyContent="flex-end"
          >
            <ShareButton
              flex={isMobile ? undefined : 1}
              phoneNumber={data.foneCliente}
              isLoading={isLoading}
              onSharePress={handleCaptureAndGeneratePDF}
              onSendSMSPress={handleSendSMS}
            />
          </View>
        }
      >
        <View flex={1} ref={viewRef} collapsable={false}>
          <VStack alignItems="center" gap={8} py="$4">
            <Icon
              name="receipt"
              color="$primary500"
              size={46}
              variant="solid"
            />
            <Text fontSize="$2xl" fontWeight={600}>
              {numberToBrl(parseFloat(data.valor))}
            </Text>
            <Text>{data.lojista}</Text>
          </VStack>
          <Divider />
          <VStack px="$6">
            <TransactionInfoSection
              title="Dados Gerais"
              icon="list"
              dateTime={formatDateTime(data?.data, data?.hora)}
              installmentValue={parseFloat(data?.prestacao)}
              value={parseFloat(data?.valor)}
              installmentsQuantity={data?.prazo}
              installmentType={data?.tipoParcelamento}
              cet={data?.cetAno}
              totalValue={data?.prazo * parseFloat(data?.prestacao)}
              interestValue={
                data?.prazo * parseFloat(data?.prestacao) -
                parseFloat(data?.valor)
              }
              paymentMethod={data?.tipoOperacao}
            />
          </VStack>
          <Divider />
          <VStack px="$6">
            <StoreInfoSection
              title="Destino"
              address={data?.endereco || "-"}
              cnpj={data?.cnpj || "-"}
              name={data?.lojista || "-"}
              phone={data?.fone || "-"}
              nsuProcessor={data?.nsuProcessadora?.toString() || "-"}
              nsuTerminal={
                parseInt(data?.nsuTerminal) ? data?.nsuTerminal : "-"
              }
              icon="circle-arrow-down"
            />
          </VStack>
          <Divider />
          <VStack px="$6">
            <ClientInfoSection
              title="Origem"
              icon="circle-arrow-up"
              name={data?.cliente}
              fone={data?.foneCliente}
              card={data?.cartao}
            />
          </VStack>
          <ReceiptFooterSection transactionId={data.autorizacao.toString()} />
        </View>
      </Scaffolds.Form>
    </Scaffolds.Root>
  );
};
export default SecondCopyOfReceipt;
